export const TYPO_PANGRAMS = [
    'Pack my box with five dozen liquor jugs.',
    'Jackdaws love my big sphinx of quartz.',
    'The five boxing wizards jump quickly.',
    'How vexingly quick daft zebras jump!',
    'Bright vixens jump; dozy fowl quack.',
    'Sphinx of black quartz, judge my vow.',
];

export const TYPO_PARAGRAPHS = `
<p>
    Lorem ipsum dolor<sup>superset</sup> amet. Aenean commodo ligula eget dolor
    Aenean
    massa. Cum sociis natoque penatibus et magnis dis<sub>subset</sub> montes,
    nascetur
    ridiculus mus.
    Donec
    quam felis, ultricies nec, pellentesque eu, pretium quis, sem. <a
        href="javascript:void(0)">Nulla
    consequat massa quis enim</a>.
    Lorem ipsum dolor sit amet, consectetuer adipiscing elit. <strong>Aenean commodo
    ligula eget
    dolor.</strong> Aenean
    massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur
    ridiculus mus. Donec
    quam felis, ultricies nec <i>italics</i> eu, pretium quis, sem. Nulla consequat
    massa quis enim.
</p>
<p>
    Commodi cumque dolorem enim esse eum harum illo illum, ipsam ipsum iure labore
    molestias
    obcaecati omnis, optio porro qui quisquam sed sit totam. Non omnis perferendis
    qui
    quia
    reiciendis.
</p>
`;

export const TYPO_RAW_PARAGRAPHS = `
    Lorem ipsum dolor sit amet, consectetur adipiscing elit, 
    sed do eiusmod tempor incididunt ut labore et dolore 
    magna aliqua. Molestie at elementum eu facilisis sed 
    odio morbi quis. Facilisi morbi tempus iaculis urna id. 
    Semper risus in hendrerit gravida rutrum quisque non 
    tellus orci. Eget dolor morbi non arcu risus.
`;

export const TYPO_SHORT_TEXT = `
    Lorem ipsum dolor sit amet
`;

export const TYPO_UL_LIST = `
<ul>
    <li>Commodi eius fugit molestias optio.</li>
    <li>Cumque ea <b>eaque</b> eveniet provident?</li>
    <li>Aliquam facilis <a href="#">nobis totam</a> ut.</li>
    <li>Dicta itaque <i>laudantium minus</i> voluptate.</li>
    <li>Animi, ratione, repellendus. Asperiores, repellat.</li>
</ul>
`;

export const TYPO_OL_LIST = `
<ol>
    <li>Fuga magni numquam omnis ratione sint?</li>
    <li>Atque <b>corporis</b> et exercitationem sapiente!</li>
    <li>Aliquam asperiores <a href="#">assumenda</a> necessitatibus nulla!</li>
    <li>Nihil provident <i>quam quidem</i> similique. Voluptatem.</li>
    <li>A assumenda dolorem nemo nesciunt quod!</li>
</ol>
`;

export const TYPO_HEADINGS = `
<div class="sty-section--heading-showcase">
    <h1>Consequat nulla - H1</h1>
</div>
<div class="sty-section--heading-showcase">
    <h2>Nam hendrerit ultricies - H2</h2>
</div>
<div class="sty-section--heading-showcase">
    <h3>Suspendisse id nunc urna - H3</h3>
</div>
<div class="sty-section--heading-showcase">
    <h4>Maecenas rhoncus hendrerit turpis - H4</h4>
</div>
<div class="sty-section--heading-showcase">
    <h5>Aenean id sapien sed libero consequat - H5</h5>
</div>
<div class="sty-section--heading-showcase">
    <h6>Phasellus efficitur malesuada urna, ut dignissim sapiens - H6</h6>
</div>
`;
